import React from "react";
import { NavLink } from "react-router-dom";
import Icon from "../../UI/Icon/Icon";
import classes from "./Sidebar.module.scss";
import { useTranslation } from "react-i18next";

const LINKS = [
  { link: "/home", text: "HOME", icon: "home" },
  { link: "/customers", text: "CUSTOMERS", icon: "avatar" },
  { link: "/zones", text: "ZONES", icon: "squares" },
  { link: "/cashier", text: "CASHIER", icon: "coin" },
  { link: "/orders", text: "ORDERS", icon: "bag" },
  { link: "/reports", text: "REPORTS", icon: "clock" },
  { link: "/settings", text: "SETTINGS", icon: "settings" },
];

const Sidebar = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.Sidebar}>
      <nav>
        <ul>
          {LINKS.map((link) => {
            return (
              <li key={link.link}>
                <NavLink
                  to={{ pathname: link.link }}
                  className={(navData) => {
                    return navData.isActive ? classes.ActiveLink : classes.Link;
                  }}
                >
                  <Icon name={link.icon} />
                  <span className={classes.LinkText}>{t(link.text)}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
